import React from 'react'

import { memo } from 'react'

import { isTrue } from '@root/utility'

export default memo(function PickableItem ({ ...props })
{
	const base_class = props.className || 'c-model-picker__item';

	const PREFIX = props['prefix'] || '##pickable-';

	let btn_class = base_class + '-btn';

	if (props.colored) btn_class += ' is-colored';

	return (
		<li className={ props.className || 'c-model-picker__item' }>

			<button type="button" data-value={ props.value }
				disabled={ isTrue(props.disabled) }
				className={ btn_class }
				onClick={ e => props.onClick(e, props.value, props.data) }
				onKeyDown={ props.onKeyDown }
				id={ props['toggle-id'] + PREFIX + props.index }
				data-option-index={ props.index }>

				{ props.label }

			</button>

		</li>
	);
});